import Axios from './axios'
import moment from 'moment'

export default {
  tentative: (serviceAreaId, token, params) => {
    const axios = Axios.setup(serviceAreaId, token)

    return new Promise((resolve,reject) => {
      axios.post('reservations/tentative', params)
        .then(payload => {
          const reservation = convert(payload.data)
          resolve(reservation)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  approve: (serviceAreaId, token, id) => {
    const axios = Axios.setup(serviceAreaId, token)

    return new Promise((resolve,reject) => {
      axios.put(`reservations/${id}/approve`)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  decline: (serviceAreaId, token, id) => {
    const axios = Axios.setup(serviceAreaId, token)

    return new Promise((resolve,reject) => {
      axios.put(`reservations/${id}/decline`)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  cancel: (serviceAreaId, token, id) => {
    const axios = Axios.setup(serviceAreaId, token)

    return new Promise((resolve,reject) => {
      axios.delete(`reservations/${id}`)
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject(error)
          })
    })
  },
  getReservation: (serviceAreaId, token, id) => {
    const axios = Axios.setup(serviceAreaId, token)

    return new Promise((resolve,reject) => {
      axios.get(`reservations/${id}`)
        .then((payload) => {
          const reservation = convert(payload.data)
          resolve(reservation)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

/*
 * Private functions
 */
function convert(data) {
  return {
    id: data.id,
    demandId: data.demandId,
    status: data.status,
    reservationId: data.reservationId,
    reservationCode: data.reservationCode,
    createdTime: moment(data.createdTime),
    latestEstimatePickUpTime: moment(data.latestEstimatePickUpTime),
    latestEstimateDropOffTime: moment(data.latestEstimateDropOffTime),
    pickUpBusstopName: data.pickUpBusstopName,
    dropOffBusstopName: data.dropOffBusstopName,
    pickUpBusstopId: data.pickUpBusstopId,
    dropOffBusstopId: data.dropOffBusstopId,
    seatCountDetail: data.seatCountDetail,
    fare: data.fare,
    sav: data.sav,
    pickUpPosition: data.pickUpPosition,
    dropOffPosition: data.dropOffPosition,
    pickUpLocationName: data.pickUpLocationName,
    dropOffLocationName: data.dropOffLocationName
  }
}
